// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__Hn0B3","subLayout":"Layout_subLayout__xzbLR","main":"Layout_main__TdNNX"};